import Avatar from '@mui/material/Avatar'
import styled from '@mui/material/styles/styled'

export const AvatarStyled = styled(Avatar, { name: 'TextAvatar' })(
  ({ theme }) => `
  background: ${theme.palette.text.primary};
  margin-right: 10px;
`,
)
